import React from "react";
import "./PrivacyPolicy.css";

function PrivacyPolicy() {

  return (

    <section className="privacy-section">

      {/* Heading */}

      <div className="privacy-heading">

        <span>Privacy Policy</span>

        <h1>
          Chennai Washcare <br />
          Privacy Policy
        </h1>

        <p>
          Chennai Washcare values customer privacy and is committed to
          protecting personal information shared through our website,
          phone calls and service bookings.
        </p>

      </div>

      {/* Content */}

      <div className="privacy-container">

        {/* Introduction */}

        <div className="privacy-card">

          <h2>Introduction</h2>

          <p>
            This Privacy Policy explains how Chennai Washcare collects,
            uses and protects customer information when using our
            washing machine repair and maintenance services.
          </p>

        </div>

        {/* Information Collection */}

        <div className="privacy-card">

          <h2>Information We Collect</h2>

          <p>
            We may collect customer information such as:
          </p>

          <ul>

            <li>
              Customer Name
            </li>

            <li>
              Phone Number
            </li>

            <li>
              Address & Location Details
            </li>

            <li>
              Email Address
            </li>

            <li>
              Washing Machine Brand & Service Details
            </li>

          </ul>

        </div>

        {/* Usage */}

        <div className="privacy-card">

          <h2>How We Use Customer Information</h2>

          <p>
            Customer information is used for:
          </p>

          <ul>

            <li>
              Service Booking Confirmation
            </li>

            <li>
              Technician Assignment
            </li>

            <li>
              Customer Support Communication
            </li>

            <li>
              Warranty & Service Follow-Up
            </li>

            <li>
              Improving Service Quality
            </li>

          </ul>

        </div>

        {/* Data Protection */}

        <div className="privacy-card">

          <h2>Customer Data Protection</h2>

          <p>
            Chennai Washcare takes appropriate security measures to
            protect customer information from unauthorized access,
            misuse or disclosure.
          </p>

          <p>
            We do not sell, rent or share personal customer information
            with third-party companies for marketing purposes.
          </p>

        </div>

        {/* Cookies */}

        <div className="privacy-card">

          <h2>Cookies & Website Tracking</h2>

          <p>
            Our website may use cookies, analytics tools and tracking
            technologies to improve website performance, understand
            visitor behavior and enhance customer experience.
          </p>

        </div>

        {/* Third Party */}

        <div className="privacy-card">

          <h2>Third Party Services</h2>

          <p>
            Our website may contain links or integrations with third-party
            services such as Google Maps, Google Ads or social media
            platforms. Chennai Washcare is not responsible for the privacy
            practices of third-party websites.
          </p>

        </div>

        {/* Service Updates */}

        <div className="privacy-card">

          <h2>Service Calls & Communication</h2>

          <p>
            Customers may receive phone calls, SMS or WhatsApp updates
            regarding service bookings, technician visits and support
            communication from Chennai Washcare.
          </p>

        </div>

        {/* Policy Changes */}

        <div className="privacy-card">

          <h2>Privacy Policy Updates</h2>

          <p>
            Chennai Washcare may update this Privacy Policy at any time
            without prior notice. Customers are encouraged to review this
            page periodically for updated information.
          </p>

        </div>

        {/* Contact */}

        <div className="privacy-card">

          <h2>Contact Information</h2>

          <p>
            If you have any questions regarding this Privacy Policy,
            you may contact Chennai Washcare support team.
          </p>

          <div className="privacy-contact-box">

            <p>
              📞+91 9790066906
            </p>

            <p>
              ✉️ chennaiwashcare210@gmail.com
            </p>

            <p>
              📍 Saidapet, Chennai, Tamil Nadu - 600015
            </p>

          </div>

        </div>

      </div>

    </section>

  );

}

export default PrivacyPolicy;